<template>
    <div class="flex items-center gap-2">
        <!-- Botão de upload -->
        <a-upload
            v-model:file-list="fileList"
            :before-upload="beforeUpload"
            :custom-request="dummyRequest"
            :accept="'.pdf'"
            :multiple="false"
            :max-count="1"
            :show-upload-list="false"
        >
            <a-button>
                <PlusOutlined />
            </a-button>
        </a-upload>

        <!-- Nome do arquivo (se houver) -->
        <span v-if="fileList.length" class="text-sm truncate max-w-xs">
      {{ fileList[0].name }}
    </span>

        <!-- Botão salvar -->
        <a-button
            :disabled="fileList.length === 0"
            shape="circle"
            :icon="h(SaveOutlined)"
            @click="handleUpload"
            title="Salvar"
        />
    </div>
</template>

<script setup>
import { h, ref } from 'vue'
import { PlusOutlined, SaveOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'

const emit = defineEmits(['on-upload'])
const fileList = ref([])
const uploading = ref(false)

const props = defineProps(['propertyId', 'type'])

const dummyRequest = ({ onSuccess }) => {
    setTimeout(() => onSuccess('ok'), 0)
}

const beforeUpload = (file) => {
    const isPDF = file.type === 'application/pdf'
    if (!isPDF) {
        message.error('Apenas arquivos PDF são permitidos.')
        return false
    }
    return true
}

const handleUpload = async () => {
    if (fileList.value.length === 0) {
        message.warning('Nenhum arquivo selecionado.')
        return
    }

    uploading.value = true

    try {
        const formData = new FormData()
        formData.append('files', fileList.value[0].originFileObj)
        formData.append('matricula', props.propertyId)
        formData.append('type', props.type)

        await window.axios.post('/photo/upload', formData)

        message.success('Arquivo enviado com sucesso!')
        fileList.value = []
        emit('on-upload')
    } catch (err) {
        console.error(err)
        message.error('Erro ao enviar o arquivo.')
    } finally {
        uploading.value = false
    }
}
</script>

<style scoped>
.flex {
    display: flex;
    align-items: center;
}
.gap-2 {
    gap: 0.5rem;
}
.max-w-xs {
    max-width: 200px;
}
.truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
